// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__HFfRR","paper":"Footer_paper__rDuSd","text":"Footer_text__lB9us","link":"Footer_link__d3ByK"};